import { observer } from 'mobx-react-lite';
import { DrawerHeader, HStack, IconButton, Text } from '@cad-arc';
import { QueueSearchInput } from '../../queues/components/queue-search-input';
import { FrUnitsTypeFilterMenu } from '../fr-units-type-filter-menu';
import { FrUnitsSortMenu } from '../fr-units-sort-menu';
import { useFrUnitsListFullscreen } from '../use-fr-units-list-fullscreen';

export const FrUnitsListHeader = observer(function FrUnitesListHeader() {
    const { expandToFullscreen } = useFrUnitsListFullscreen();

    return (
        <DrawerHeader>
            <HStack justifyContent="space-between" flex="1">
                <Text variant="headingLg" fontWeight="bold">
                    Units
                </Text>
                <HStack justifyContent="flex-end" pr={8}>
                    <QueueSearchInput searchButtonVariant="outline" />
                    <FrUnitsTypeFilterMenu />
                    <FrUnitsSortMenu />
                    <IconButton
                        data-testid="UNITS_LIST_EXPAND_DRAWER"
                        aria-label="expand units drawer"
                        icon="ExpandWindow"
                        onClick={expandToFullscreen}
                        variant="outline"
                    />
                </HStack>
            </HStack>
        </DrawerHeader>
    );
});
